module.exports = __webpack_public_path__ + "static/media/metamask.0c4d19aa.svg";